import React, { useMemo } from "react";
import { Container, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import Autocomplete from "../../components/Autocomplete";
import LinkedList from "../../components/LinkedList";

const DrugCkeck = ({ navigate, location }) => {
  const mostCommonSearchs = useMemo(
    () => [
      {
        label: "Citalopram",
        link: "results?searchLabel=Citalopram&searchType=active_ingredient_name&searchByName=true",
      },
      {
        label: "Clopidogrel",
        link: "results?searchLabel=Clopidogrel&searchType=active_ingredient_name&searchByName=true",
      },
      {
        label: "Codein",
        link: "results?searchLabel=Codein&searchType=active_ingredient_name&searchByName=true",
      },
      {
        label: "Warfarin",
        link: "results?searchLabel=Warfarin&searchType=active_ingredient_name&searchByName=true",
      },
      {
        label: "Simvastatin",
        link: "results?searchLabel=Simvastatin&searchType=active_ingredient_name&searchByName=true",
      },
    ],
    []
  );

  return (
    <Container fluid className="drug-check p-5">
      <Row>
        <Col>
          <h5>
            <FormattedMessage id="search.intro" />
          </h5>
        </Col>
      </Row>
      <Row>
        <Col lg="10" className="drug-search-field">
          <Autocomplete navigate={navigate} location={location} />
        </Col>
      </Row>
      <Row>
        <Col md="6" lg="5" className="common-search-items">
          <span>
            <FormattedMessage id="search.most_common_search" />
          </span>
          <LinkedList listItems={mostCommonSearchs} />
        </Col>
      </Row>
    </Container>
  );
};

export default DrugCkeck;
